import React from 'react';
import Script from 'next/script';

const GoogleAnalyticsScript = ({currentUser}) => (currentUser ? (
  <Script id="google-analytics">
    {`if (window.dataLayer) window.dataLayer.push({'userId': '${currentUser.id}'});`}
  </Script>
) : null);

export default GoogleAnalyticsScript;
